export const SPLASH_VISIBLE = "SPLASH_VISIBLE";
export const SPLASH_INVISIBLE = "SPLASH_INVISIBLE";
export const SPLASH_CHANGE_VALUE = "SPLASH_CHANGE_VALUE";
